/**
 * @file DevicePreview.tsx
 * @module DevicePreview
 * @description
 *   Mount point for the Device Preview tab. Guards rendering behind
 *   feature flag and user auth, wraps content in RDPProvider and error boundary.
 */

import { useCallback } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { RDPProvider } from '@amzn/noolpaavai-react';
import { useAuthentication } from 'src/contexts/AuthenticationContext';
import { getUserAlias } from 'src/components/authentication/AuthenticationUtils';
import { getRdpStage } from 'src/configs/rdpConfiguration';
import { FeatureFlag, isFeatureEnabled } from 'src/featureFlags';

import { DevicePreviewErrorBoundary } from './DevicePreviewErrorBoundary';
import { DevicePreviewContent } from './DevicePreviewContent';

export const DevicePreview = () => {
  const { user } = useAuthentication();

  const getAuthToken = useCallback(
    async () => (await fetchAuthSession()).tokens?.idToken?.toString() ?? '',
    [],
  );

  if (!isFeatureEnabled(FeatureFlag.RdpIntegration) || !user) {
    return null;
  }

  return (
    <DevicePreviewErrorBoundary>
      <RDPProvider
        config={{
          stage: 'beta',
          getAuthToken,
          userId: getUserAlias(user),
        }}
      >
        <DevicePreviewContent />
      </RDPProvider>
    </DevicePreviewErrorBoundary>
  );
};
